import httpService from "./../services/httpService";
import {
  BOOKING_ADD_ITEM,
  BOOKING_REMOVE_ITEM,
  BOOKING_SAVE_DELIVERY_ADDRESS,
  BOOKING_SAVE_PAYMENT_METHOD,
} from "../constants/bookingConstants";

export const addToBooking = (id, qty) => async (dispatch, getState) => {
  const { data } = await httpService.get(`/api/products/${id}`);

  dispatch({
    type: BOOKING_ADD_ITEM,
    payload: {
      product: data._id,
      name: data.name,
      image: data.image,
      price: data.price,
      countInStock: data.countInStock,
      qty,
      isDozen: data.isDozen,
      type: data.type,
    },
  });

  localStorage.setItem(
    "bookingItems",
    JSON.stringify(getState().booking.bookingItems)
  );
};

export const removeFromBooking = (id) => (dispatch, getState) => {
  dispatch({
    type: BOOKING_REMOVE_ITEM,
    payload: id,
  });

  localStorage.setItem(
    "bookingItems",
    JSON.stringify(getState().booking.bookingItems)
  );
};

export const saveDeliveryAddress = (data) => (dispatch) => {
  dispatch({
    type: BOOKING_SAVE_DELIVERY_ADDRESS,
    payload: data,
  });

  localStorage.setItem("deliveryAddress", JSON.stringify(data));
};

export const savePaymentMethod = (data) => (dispatch) => {
  dispatch({
    type: BOOKING_SAVE_PAYMENT_METHOD,
    payload: data,
  });

  localStorage.setItem("paymentMethod", JSON.stringify(data));
};
